let alertHandler = (message) => window.alert(message);
let confirmHandler = (message) => Promise.resolve(window.confirm(message));

export function registerDialogHandlers(handlers) {
  alertHandler = handlers.alertHandler;
  confirmHandler = handlers.confirmHandler;
}

export function resetDialogHandlers() {
  alertHandler = (message) => window.alert(message);
  confirmHandler = (message) => Promise.resolve(window.confirm(message));
}

/**
 * 알림 다이얼로그.
 * @param message 본문 메시지
 * @param options { title } - 제목 override (기본 "알림")
 */
export function alertDialog(message, options) {
  alertHandler(String(message ?? ""), options ?? {});
}

/**
 * 확인 다이얼로그 (Promise<boolean> 반환).
 * @param message 본문 메시지
 * @param options { title, confirmLabel, cancelLabel } - 제목/버튼 문구 override
 */
export function confirmDialog(message, options) {
  return confirmHandler(String(message ?? ""), options ?? {});
}

/**
 * 등록/수정 화면 이탈(이전·취소) 공용 가드.
 * 입력(등록) 또는 변경(수정) 내용이 없으면(dirty=false) 모달 없이 통과한다.
 * 있으면 확인 모달을 띄워 사용자의 선택을 그대로 반환한다.
 *
 * @param {boolean} dirty - 입력/변경 내용 존재 여부
 * @param {string} message - 확인 모달 문구
 * @returns {Promise<boolean>} 이탈해도 되면 true
 */
export function confirmLeaveIfDirty(dirty, message) {
  if (!dirty) return Promise.resolve(true);
  return confirmDialog(message);
}
